
/* global attachEvent, YT */

attachEvent('.embed-video__poster', 'click', (ev) => {
  let player;
  const number = Math.floor(Math.random() * 10000 + 1);
  const parent = ev.target.closest('.embed-video');
  const videoURL = ev.target.closest('.embed-video__poster').getAttribute('data-id');
  const idString = 'id_';
  const videoID = idString.concat('', number);

  // Add class to parent for hiding poster
  parent.classList.add('is-playing');

  // Set the div ID to match API player ID
  parent.querySelectorAll('.embed-video__iframe-container')[0].id = videoID;

  // API EVENT: Play
  function onPlayerReady(event) {
    event.target.playVideo();
  }

  // API EVENT: Check for ending
  function onPlayerStateChange(event) {
    if (event.data === 0) {
      // Stop and destroy player (stops video and removes player instance and iframe)
      parent.classList.remove('is-playing');
      player.stopVideo();
      player.destroy();
      player = null;
    }
  }

  // API: Create new player
  player = new YT.Player(videoID, {
    // Set the api ID to match div ID
    videoId: videoURL,
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
  });
});
